import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {titleCase} from "../../../../utils/utils"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function UnitedKingdomTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };         

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Nome da Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Tipo da Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Outros Nomes</TableCell>
            <TableCell className={classes.tableHeader}>Outras Informações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.unitedKingdom_data.map((sanction,index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            > 
              <TableCell className={classes.tableText}>
                {titleCase(sanction.sanction_name, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.type, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.aliases.join('; '), "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.other_information, "-")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default UnitedKingdomTable;